var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 162.42 150.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-4,.cls-5,.cls-7,.cls-8,.cls-9{fill:none;}.cls-1,.cls-2,.cls-4,.cls-5{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-2{stroke-width:2px;}.cls-2{stroke-dasharray:0.2 5 0.2 5 0.2 5;}.cls-3{fill:#fff;}.cls-5{stroke-width:3px;}.cls-6{fill:#33b8ce;}.cls-7,.cls-8,.cls-9{stroke:#33b8ce;stroke-miterlimit:10;}.cls-7{stroke-opacity:0.8;}.cls-8{stroke-opacity:0.6;}.cls-9{stroke-opacity:0.4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.35,134a74.17,74.17,0,0,1-98-110.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.34,23.11A73.93,73.93,0,0,1,75.17,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.17,1c40.74,0,75.13,32.86,75.49,73.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "140.81 70.22 148.32 88.69 160.57 72.95 140.81 70.22"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 75.17,
    y1: 1.81,
    x2: 75.17,
    y2: 11.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 75.17,
    y1: 137.91,
    x2: 75.17,
    y2: 149.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 149.32,
    y1: 75.5,
    x2: 138.02,
    y2: 75.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 12.32,
    y1: 75.5,
    x2: 1.01,
    y2: 75.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 108.71,
    y1: 17.06,
    x2: 111.95,
    y2: 11.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 38.16,
    y1: 139.14,
    x2: 41.4,
    y2: 133.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 16.7,
    y1: 109.18,
    x2: 11.08,
    y2: 112.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 139.03,
    y1: 38.52,
    x2: 133.41,
    y2: 41.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 133.41,
    y1: 109.24,
    x2: 139.03,
    y2: 112.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 10.92,
    y1: 38.52,
    x2: 16.53,
    y2: 41.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 41.23,
    y1: 17.06,
    x2: 37.99,
    y2: 11.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 111.95,
    y1: 139.55,
    x2: 108.71,
    y2: 133.94
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "74.5 21.96 74.5 75.17 105.43 94.45"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 139.03,
    cy: 112.48,
    r: 7.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 139.03,
    cy: 112.48,
    r: 11.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 139.03,
    cy: 112.48,
    r: 17.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 139.03,
    cy: 112.48,
    r: 22.89
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/Icon6.525d9c6e082954c201c118f05a6c4416.svg";
export { ForwardRef as ReactComponent };